import type { FC } from "react";

import { Delete } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { SurveyGroupResponse } from "@rubi/api-generated";

import styles from "./SurveyGroupManagement.module.scss";

export interface SurveyGroupCardProps {
  group: SurveyGroupResponse;
  getConfigName: (id: string) => string;
  onManage: () => void;
  onDelete: () => void;
}

const SurveyGroupCard: FC<SurveyGroupCardProps> = ({
  group,
  getConfigName,
  onManage,
  onDelete,
}) => {
  return (
    <Paper variant="outlined" className={styles.groupCard}>
      <Grid container alignItems="flex-start" spacing={2}>
        <Grid size={{ xs: 12, sm: 8 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6">{group.name}</Typography>
            {group.hidden && (
              <Chip label="Hidden" size="small" color="default" />
            )}
            {group.sort_order != null && (
              <Chip
                label={`Order: ${group.sort_order}`}
                size="small"
                variant="outlined"
              />
            )}
          </Stack>
          <Box className={styles.surveyListWrap}>
            {group.survey_config_ids.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No surveys assigned
              </Typography>
            ) : (
              <List dense disablePadding>
                {group.survey_config_ids.map((id) => (
                  <ListItem key={id} disablePadding>
                    <ListItemText
                      primary={getConfigName(id)}
                      primaryTypographyProps={{ variant: "body2" }}
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} className={styles.actionsCell}>
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button size="small" variant="outlined" onClick={onManage}>
              Manage
            </Button>
            <Tooltip title="Delete group">
              <IconButton size="small" color="error" onClick={onDelete}>
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SurveyGroupCard;
